import { type LinearConfiguration } from "../../Linear/models";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type CsticUpdate } from "../../Linear/api/sendLinearConfiguratorUpdate";
import { prepareCommonShaftData, sendShaft } from "./sendShaftCommon";
import { prepareApiDataForUpdate } from "../../common/commonConfiguratorApi";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { radialThread, SHAFT_MACHINING_MIDDLE } from "~/Configurators/Shaft/metric/metricCsticConstants";
import { KmatType } from "~/Configurators/Linear/kmatType";

export function sendShaftUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration> {
  const data = prepareCommonShaftData(linearState);

  if (linearState.type === ConfiguratorType.MetricShaft) {
    const middleMachiningValue = linearState.kmats[KmatType.Main][0].cstics[SHAFT_MACHINING_MIDDLE]?.value;
    const alarModeValue = linearState.kmats[KmatType.Main][0].cstics[radialThread.aLaRMode]?.value;

    if (middleMachiningValue === "980" && !alarModeValue) {
      updatedCstics.push({
        key: radialThread.aLaRMode,
        type: KmatType.Main,
        index: 0,
        value: "S",
      });
    }
  }

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  return sendShaft({
    ...data,
    ...updateData,
  });
}
